import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import PricingView from '../views/PricingView.vue';
import FeaturesView from '../views/FeaturesView.vue';
import PrivacyView from '@/views/PrivacyView.vue';
import CookieView from '@/views/CookieView.vue';
import FaqView from '@/views/FAQView.vue';
import ContactView from '@/views/ContactView.vue';

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            title: 'Home - ImmobilAutoManager',
        },
    },
    {
        path: '/caratteristiche',
        name: 'features',
        component: FeaturesView,
        meta: {
            title: 'Caratteristiche - ImmobilAutoManager',
        },
    },
    {
        path: '/chi-siamo',
        name: 'about',
        component: () => import('../views/AboutView.vue'),
        meta: {
            title: 'Chi Siamo - ImmobilAutoManager',
        },
    },
    {
        path: '/prezzi',
        name: 'pricing',
        component: PricingView,
        meta: {
            title: 'Prezzi - ImmobilAutoManager',
        },
    },
    {
        path: '/contatti',
        name: 'contact',
        component: () => import('../views/ContactView.vue'),
        meta: {
            title: 'Contatti - ImmobilAutoManager',
        },
    },
    {
        path: '/faq',
        name: 'faq',
        component: () => import('../views/FAQView.vue'),
        meta: {
            title: 'FAQ - ImmobilAutoManager',
        },
    },
    {
        path: '/admin/pricing',
        name: 'adminPricing',
        component: () => import('../views/AdminPricingView.vue'),
        meta: {
            requiresAuth: true,
            adminOnly: true,
        },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: PrivacyView,
    },
    {
        path: '/cookies',
        name: 'cookies',
        component: CookieView,
    },
    {
        path: '/faq',
        name: 'faq',
        component: FaqView,
    },
    {
        path: '/contact',
        name: 'contact',
        component: ContactView,
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            };
        }
        return { top: 0 };
    },
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'ImmobilAutoManager';
    next();
});

export default router;
